import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import {
  JSONToCSVConvertor,
  bulkReqTracker,
} from "../../../helpers/helperFunctions";
import { changeVehicle } from "./historyReport/historyReport";
import _ from "lodash";
import moment from "moment";
import humanizeDuration from "humanize-duration";

const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms",
    },
  },
});

const getReport = (schema, data, store) => {
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, true);
  let starttime = moment(data.starttime, "DD/MM/YYYY").valueOf();
  let endtime = moment(data.endtime, "DD/MM/YYYY").valueOf();
  const auth = window.getAuth();
  let vehicleid = [];
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
  data.vehicle.map((index) => {
    vehicleid.push(index.data.vehicleid);
  });

  let tableData = [];
  const handleSuccess = (resp) => {
    let tableResp = resp[0].tabledata;
    window.rideReportData = resp[0];
    let trips = window.rideReportData.graphdata[0].distancebucket;
    window.distanceData = [
      {
        id: "1-10",
        label: "1-10",
        value: trips[0] ? trips[0] : 0,
      },
      {
        id: "10-30",
        label: "10-30",
        value: trips[1] ? trips[1] : 0,
      },
      {
        id: "30-60",
        label: "30-60",
        value: trips[2] ? trips[2] : 0,
      },
      {
        id: "60-90",
        label: "60-90",
        value: trips[3] ? trips[3] : 0,
      },
      {
        id: ">90",
        label: ">90",
        value: trips[4] ? trips[4] : 0,
      },
    ];

    let tripdata = window.rideReportData.graphdata[0].tripdata;
    window.avgtripdata = [];
    window.totaltripdata = [];
    for (let i = 0; i < tripdata.length; i++) {
      window.avgtripdata.push({
        xData: moment(tripdata[i].date).format("MMM-DD"),
        yData: tripdata[i].avgtrips,
        TotalVehicle: tripdata[i].novehicles,
      });
    }
    for (let i = 0; i < tripdata.length; i++) {
      window.totaltripdata.push({
        xData: moment(tripdata[i].date).format("MMM-DD"),
        yData: tripdata[i].trips,
        TotalVehicle: tripdata[i].novehicles,
      });
    }
    let speedData = window.rideReportData.graphdata[0].speedbucket;

    window.speedData = [
      {
        id: "1-10",
        label: "1-10",
        value: speedData[0] ? speedData[0] : 0,
      },
      {
        id: "10-30",
        label: "10-30",
        value: speedData[1] ? speedData[1] : 0,
      },
      {
        id: "30-60",
        label: "30-60",
        value: speedData[2] ? speedData[2] : 0,
      },
      {
        id: "60-90",
        label: "60-90",
        value: speedData[3] ? speedData[3] : 0,
      },
      {
        id: ">90",
        label: ">90",
        value: speedData[4] ? speedData[4] : 0,
      },
    ];

    let operatingTime = window.rideReportData.graphdata[0].operatingtimedata;
    window.opTime = [];
    for (let i = 0; i < operatingTime.length; i++) {
      window.opTime.push({
        Date: moment(operatingTime[i].date).format("MMM-DD"),
        Running: (operatingTime[i].runningtime / 1000 / 60).toFixed(0),
        Stoppage: (operatingTime[i].stoppagetime / 1000 / 60).toFixed(0),
        Vehicles: operatingTime[i].novehicles,
      });
    }

    for (let i = 0; i < tableResp.length; i++) {
      for (let j = 0; j < tableResp[i].length; j++) {
        let obj = tableResp[i][j];
        obj.opeartingtime = shortEnglishHumanizer(obj.opeartingtime, {
          round: true,
          largest: 2,
        });
        obj.runningtime = shortEnglishHumanizer(obj.runningtime, {
          round: true,
          largest: 2,
        });
        obj.stoppagetime = shortEnglishHumanizer(obj.stoppagetime, {
          round: true,
          largest: 2,
        });
        obj.avgrunningtime = shortEnglishHumanizer(obj.avgrunningtime, {
          round: true,
          largest: 2,
        });
        obj.avgstoppagetime = shortEnglishHumanizer(obj.avgstoppagetime, {
          round: true,
          largest: 2,
        });
        obj.date = moment(obj.date).format("DD-MMM");
        obj.totaldistance =
          obj.totaldistance % 1 != 0
            ? parseFloat(obj.totaldistance).toFixed(2)
            : obj.totaldistance;
        obj.avgdistance =
          obj.avgdistance % 1 != 0
            ? parseFloat(obj.avgdistance).toFixed(2)
            : obj.avgdistance;
        tableData.push(tableResp[i][j]);
      }
    }

    let aggregate = window.rideReportData.aggregate;
    let aggregatetable = [];
    for (let i = 0; i < aggregate.length; i++) {
      let obj = aggregate[i];
      obj.allopeartingtime = shortEnglishHumanizer(obj.allopeartingtime, {
        round: true,
        largest: 2,
      });
      obj.allrunningtime = shortEnglishHumanizer(obj.allrunningtime, {
        round: true,
        largest: 2,
      });
      obj.allstoppagetime = shortEnglishHumanizer(obj.allstoppagetime, {
        round: true,
        largest: 2,
      });
      obj.allavgrunningtime = shortEnglishHumanizer(obj.allavgrunningtime, {
        round: true,
        largest: 2,
      });
      obj.allavgstoppagetime = shortEnglishHumanizer(obj.allavgstoppagetime, {
        round: true,
        largest: 2,
      });
      obj.date =
        moment(obj.date[0]).format("DD-MMM") +
        " to " +
        moment(obj.date[1]).format("DD-MMM");
      obj.alltotaldistance =
        obj.alltotaldistance % 1 != 0
          ? parseFloat(obj.alltotaldistance).toFixed(2)
          : obj.alltotaldistance;
      obj.allavgdistance =
        obj.allavgdistance % 1 != 0
          ? parseFloat(obj.allavgdistance).toFixed(2)
          : obj.allavgdistance;
      obj.allmaxdistance =
        obj.allmaxdistance % 1 != 0
          ? parseFloat(obj.allmaxdistance).toFixed(2)
          : obj.allmaxdistance;
      aggregatetable.push(aggregate[i]);
    }

    window.aggregate = aggregatetable;
    window.rideReportTable = tableData;
    window.renderRideTable = true;
    window.setReportWindowTabBusy(schema, false);
  };
  let body = {
    token: auth.token,
    starttime: starttime,
    endtime: endtime,
    vehicleid: vehicleid,
  };
  if (window.showNoGpsFixData === true) {
    body.fixqfilter = false;
  }
  ReportAPIs.getRideReport(body).then(handleSuccess, (r) => {
    handleSuccess({});
  });
};

const downloadReport = (schema) => {
  const keysToRemove = [
    "tripstart",
    "tripend",
    "uid",
    "trips",
    "vehicleid"
  ];

  const cleanedData = window.rideReportTable.map((item) => {
    const newItem = { ...item };
    keysToRemove.forEach(key => delete newItem[key]);
    return newItem;
  });
  JSONToCSVConvertor(cleanedData, "Ride Report", false);
};

const schema = {
  key: "tvs_report",
  name: "Ride Report",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: (window.selectedVehicles || []).map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Ride Report",
      onClick: getReport,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: downloadReport,
    },
  ],
  content: [
    {
      key: "reportwidget",
      type: schemaTypes.TVS_REPORT_WIDGET,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
